module.exports = __webpack_public_path__ + "media/img/sbt-test/visa-9a2bc0270b6a0671fb3e33f240aa9398.svg";